import React from 'react';
import { InitialAssignableType } from '@/components/shared/LessonOverview/Cards/AssignButton';
import useLessonOverviewContext from '@/components/shared/NewLessonOverview/useLessonOverviewContext';
import AssignButton from './AssignButton';
import GoToButton from './GoToButton';

interface ActionBarProps {
  children?: ReactChildren;
  href: string;
  iconType: 'play' | 'arrow';
  initialValues?: InitialAssignableType;
  isAssigned?: boolean;
  isStaffer?: boolean;
  label?: string;
}

const ActionBar = ({
  children,
  href,
  iconType,
  initialValues,
  isAssigned,
  isStaffer,
  label,
}: ActionBarProps) => {
  const staffer = isStaffer ?? useLessonOverviewContext(state => state.isStaffer);

  return (
    <div className="tw-py-2.5 tw-px-4 tw-mx-2">
      <div className="tw-h-auto tw-text-center tw-leading-[30px] tw-flex tw-items-center">
        <GoToButton useNewIcon href={href} iconType={iconType} label={label} />
        {staffer && (
          <AssignButton
            circle
            initialValues={initialValues}
            isAssigned={isAssigned}
          />
        )}
        {children}
      </div>
    </div>
  );
};

export default ActionBar;
